import React, { useState } from 'react';
import { FormsyText } from 'formsy-material-ui/lib';
import Formsy from 'formsy-react';
import { Box } from '@material-ui/core';
import { textFieldStyle } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';
import { phoneNumber } from '../../../settings/constants/regex';

const locale = globals.getArea('patients');
const errorsLocale = globals.getArea('error');

export default function ContactDetails({ readOnly, patientContact, innerRef, setValidity, getPatientPhoneNumbers }) {
  const [state, setState] = useState({
    landlinePhoneNumber: patientContact.landlinePhoneNumber,
    otherPhoneNumber: patientContact.otherPhoneNumber,
    mobilePhoneNumber: patientContact.mobilePhoneNumber,
  });

  const errorMessages = {
    matchRegexp: errorsLocale.getMsg('invalidFormat'),
  };

  const handleChange = () => {
    const phoneCallContact = {
      landlinePhoneNumber: state.landlinePhoneNumber,
      otherPhoneNumber: state.otherPhoneNumber,
      mobilePhoneNumber: state.mobilePhoneNumber,
    };
    getPatientPhoneNumbers(phoneCallContact);
  };

  return (
    <div>
      <Formsy.Form ref={innerRef} onChange={handleChange} onValid={setValidity(true)} onInvalid={setValidity(false)}>
        <Box p={1} flexGrow={1} style={{ width: '25%' }}>
          <FormsyText
            name="homeTelephone"
            validations={{ matchRegexp: phoneNumber }}
            validationErrors={errorMessages}
            floatingLabelStyle={textFieldStyle.floatingLabelStyle}
            floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
            style={textFieldStyle.style}
            inputStyle={textFieldStyle.inputStyle}
            underlineStyle={textFieldStyle.underlineStyle}
            floatingLabelText={`${locale.getMsg('landlinePhoneNumber')} *`}
            value={state.landlinePhoneNumber || ''}
            validationColor={textFieldStyle.validationColor}
            disabled={readOnly}
            required
            onChange={e => setState({ ...state, landlinePhoneNumber: e.target.value })}
            errorStyle={textFieldStyle.errorStyle}
          />
        </Box>
        <Box p={1} flexGrow={1} style={{ width: '25%' }}>
          <FormsyText
            name="workTelephone"
            validations={{ matchRegexp: phoneNumber }}
            validationErrors={errorMessages}
            floatingLabelStyle={textFieldStyle.floatingLabelStyle}
            floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
            style={textFieldStyle.style}
            inputStyle={textFieldStyle.inputStyle}
            underlineStyle={textFieldStyle.underlineStyle}
            floatingLabelText={locale.getMsg('otherPhoneNumber')}
            value={state.otherPhoneNumber || ''}
            validationColor={textFieldStyle.validationColor}
            disabled={readOnly}
            onChange={e => setState({ ...state, otherPhoneNumber: e.target.value })}
            errorStyle={textFieldStyle.errorStyle}
          />
        </Box>
        <Box p={1} flexGrow={1} style={{ width: '25%' }}>
          <FormsyText
            name="mobileTelephone"
            validations={{ matchRegexp: phoneNumber }}
            validationErrors={errorMessages}
            floatingLabelStyle={textFieldStyle.floatingLabelStyle}
            floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
            style={textFieldStyle.style}
            inputStyle={textFieldStyle.inputStyle}
            underlineStyle={textFieldStyle.underlineStyle}
            floatingLabelText={locale.getMsg('mobilePhoneNumber')}
            validationColor={textFieldStyle.validationColor}
            value={state.mobilePhoneNumber || ''}
            disabled={readOnly}
            onChange={e => setState({ ...state, mobilePhoneNumber: e.target.value })}
            errorStyle={textFieldStyle.errorStyle}
          />
        </Box>
      </Formsy.Form>
    </div>
  );
}
